// extracted by mini-css-extract-plugin
export default {"main":"Home_main__RBgDl","message":"Home_message__nLeus","show":"Home_show__G3Nnl"};